<template>
  <div class="footer-wrapper">
    <div class="contact">
      <div class="left">
        <h1>关于我们：</h1>
        <a
          href="http://www.g12e.org/zt/gywm/?tabs=1&&tag=1"
          target="_blank"
          title="联盟简介"
        >联盟简介</a>
        <a
          href="http://www.g12e.org/zt/hezuo/"
          target="_blank"
          title="合作方式"
        >合作方式</a>
        <a
          href="http://www.g12e.org/zt/zhinan/?tabs=1&&tag=1"
          target="_blank"
          title="操作指南"
        >操作指南</a>
        <a
          href="http://www.g12e.org/zt/changjian/?tabs=1&&tag=1"
          target="_blank"
          title="常见问题"
        >常见问题</a>
      </div>
      <div class="middle">
        <h1>联系我们：</h1>
        <p>联盟电话：010-82501118</p>
        <p>免费热线：4006500666</p>
        <p>技术支持：010-82330666</p>
        <p>投诉渠道：lianmeng@cdeledu.com</p>
      </div>
      <div class="right">
        <h1>了解更多：</h1>
        <ul class="ewm clearfix">
          <li><img
              src="//www.g12e.org/upload/resources/image/2020/07/10/25127.png"
              alt="联盟网"
            /></li>
          <li><img
              src="//www.g12e.org/upload/resources/image/2020/07/10/25128.png"
              alt="微博"
            /></li>
          <li><img
              src="//www.g12e.com/upload/resources/image/2021/01/29/27211.png"
              alt="微信"
            /></li>
        </ul>
      </div>
    </div>
    <!--eslint-disable-->
    <div class="copyright">
      <p>中小学教育联盟网 版权所有 2006-2021</p>
      <p>
        <a
          href="http://www.g12e.org/zhuanti/zh20200716182927.shtml"
          target="_blank"
          rel="external nofollow"
        >京ICP证B2-20200405</a>　
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="external nofollow"
        >京ICP备09083774号-1</a>　
        <a
          href="http://www.g12e.org/zhuanti/ji20200716095104.shtml"
          target="_blank"
          rel="external nofollow"
        >电信业务审批[2009]字第514号</a>　
      </p>
      <p>
        <a
          target="_blank"
          href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802023424"
        >
          <img
            src="//www.chinaacc.com/images/ba-icon.png"
            border="0"
            style="display:inline-block;vertical-align:middle;margin:-3px 3px 0 0"
            width="20"
            height="20"
          />
          京公网安备 11010802023424号
        </a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppFooter'
}
</script>
